<template>
  <div>
    <ul>
      <li
        class="article_body"
        v-for="item in articleList[$route.params.id - 1].children"
        :key="item.id"
        @click="routerTo(item)"
      >
        <div class="article_header">
          <h4>{{item.hovertitle}}</h4>
          <div class="articl_time">{{item.createTime}}</div>
        </div>
        <div class="article_content">
          {{item.content}}
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { MenuList } from './data/data'

export default {
  name: 'ArticleList',
  data () {
    return {
      articleList: MenuList.content
    }
  },
  methods: {
    routerTo (item) {
      this.$router.push(item.routerUrl)
      this.$emit('chooseAticle', item.hovertitle)

    }
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.article_body {
  cursor: pointer;
  padding: 10px 5px 20px 5px;
  border-bottom: 1px dashed #d9d9d9;

  .article_header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h4{
      font-size: 16px;
    }

    .articl_time {
      color: #a9a8a7;
      font-size: 12px;
    }
  }

  .article_content {
    margin: 10px;
    line-height: 20px;
    overflow: hidden;
    width: 100%;
    font-size: 12px;
    color: #515050;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .article_content:hover {
    color: #bc1b21;
  }
}
</style>